/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Energy Type that is used for filtering.
 *
 */
export var AssetStatsPropertyForFiltering;
(function (AssetStatsPropertyForFiltering) {
    AssetStatsPropertyForFiltering["PROJECT_ID"] = "projectId";
    AssetStatsPropertyForFiltering["ASSET_SOURCE_TYPE"] = "assetSourceType";
    AssetStatsPropertyForFiltering["ASSET_ID"] = "assetId";
    AssetStatsPropertyForFiltering["AGGREGATION_TYPE"] = "aggregationType";
})(AssetStatsPropertyForFiltering || (AssetStatsPropertyForFiltering = {}));
